module.exports = __webpack_public_path__ + "img/productBgImg21.82ad4d9a.png";